import { createFileRoute } from '@tanstack/react-router'
import { CapabilityPage } from '@/components/engineering/EngineeringPages'
import { localizedPageHead } from '@/lib/seo-head'

export const Route = createFileRoute('/{-$locale}/ai')({
  head: ({ params }) => localizedPageHead('ai', params.locale),
  component: () => <CapabilityPage kind="ai" />,
})
